import styled from 'styled-components';

export const EnrollmentChangesCardContainer = styled.div`
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 30px;
  width: 249px;
  height: 220px;
  border-radius: 4px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 20px #00000029;
`;

export const CardImgContainer = styled.div`
  display: flex;
  flex-grow: 2;

  background-position: center;
  height: 186px;
  width: 249px;
  border-radius: 4px 4px 0 0;
`;

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

export const IconCardSlot = styled.div`
  display: flex;
  width: 35px;
  height: 36px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  margin-top: 9px;
  margin-left: -40px;
  cursor: pointer;
`;

export const WaiveCardSlot = styled.div`
  display: flex;
  width: 70px;
  height: 36px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  margin-top: 146.4px;
  margin-left: -219px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  background-color: #d50b30;
  color: white;
  cursor: pointer;
`;

export const EnrollCardSlot = styled.div`
  display: flex;
  width: 70px;
  height: 36px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  margin-top: 146.4px;
  margin-left: 55px;
  margin-right: -30px;
  background-color: #0b9500;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  color: white;
  cursor: pointer;
`;

export const AbsoluteIcon = styled.div`
  margin: auto;
  align-items: center;
  svg {
    fill: #fff;
    height: auto;
  }
`;

export const CardContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  background: transparent linear-gradient(180deg, #ffffff 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 4px 4px;
  box-shadow: 0px 5px 5px #00000029;
`;

export const CardContentTitle = styled.p`
  font-size: 16px;
  color: #1c1b3a;
  font-weight: 600;
  padding-top: 10px;
  margin: 0;
  min-height: 55px;
  text-wrap: wrap;
  text-align: center;
`;
